// extracted by mini-css-extract-plugin
export default {"productGallery":"ZL-z","inQuickShop":"_L-z"};